"use client";

import { Container } from "@/components/ui/container";
import { Section } from "@/components/ui/section";
import { Badge } from "@/components/ui/badge";
import { CommunityWordmark } from "./community-wordmark";

const HERO_BADGES = [
  { label: "Partner Dropshipping", variant: "primary" as const },
  { label: "Wholesale", variant: "secondary" as const },
  { label: "Marketplace", variant: "marketplace" as const },
];

export function CommunityHero() {
  return (
    <Section
      background="white"
      size="sm"
      className="bg-retro-paper pt-6 pb-5 md:pt-16 md:pb-8 lg:pt-20 lg:pb-10"
    >
      <Container className="text-center">
        <p className="mb-4 font-mono text-[11px] font-bold uppercase tracking-[0.22em] text-brand-green">
          Buddify presents
        </p>
        <CommunityWordmark className="mb-4 md:mb-8 max-w-full px-[0.16em] py-[0.14em] text-[clamp(2.25rem,12vw,5.5rem)] tracking-[0.04em] shadow-[5px_5px_0_#173c17] sm:shadow-[7px_7px_0_#173c17]" />
        <h1 className="mx-auto mb-4 max-w-6xl font-heading text-[1.75rem] font-bold leading-[1.1] tracking-[-0.025em] text-ink [text-wrap:balance] md:text-[3rem] lg:text-[3.75rem]">
          <span className="lg:block">
            Discover independent brands, products,
          </span>{" "}
          <span className="lg:block">and your next business partnership.</span>
        </h1>
        <p className="mx-auto mb-4 md:mb-7 max-w-2xl text-sm md:text-lg text-muted">
          Explore independent brands by region, category, and curated collection,
          then find the right partners for your next move.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-2">
          {HERO_BADGES.map((badge) => (
            <Badge key={badge.label} variant={badge.variant}>
              {badge.label}
            </Badge>
          ))}
        </div>
      </Container>
    </Section>
  );
}
